var React = require('react');

function Arrows2 (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M225 6.82573C225 6.82573 181.461 39.9971 115.666 39.9971C49.8702 39.9971 6.33101 6.82571 6.33101 6.82571","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"12 8","key":0}),React.createElement("path",{"d":"M7.5498 16.9902L5.57235 6.17306L18.6943 4.64318","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Arrows2.defaultProps = {"viewBox":"0 0 226 41","fill":"none"};

module.exports = Arrows2;

Arrows2.default = Arrows2;
